






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import EditBaseSeo from '@/components/shared/EditBaseSeo.vue'
import { AloPiscine,getDefaultAloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'EditPage',     
  components:{EditBasePiscine,EditBaseSeo}
})
export default class EditPage extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()

  edit(item:AloPiscine) {            
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)    
  }        
}
